import { atom } from "jotai";
import { atomWithStorage, createJSONStorage } from "jotai/utils";

export interface ScannedDevice {
  id?: number;
  stateId?: number;
  eolTrackingNumber?: string;
  orderId?: number;
  classificationCategoryId?: number;
  manufacturer?: string;
  chgManufacturerId?: string;
  productName?: string; // productName
  serialNumber?: string;
  readSerialNumber: string;
  assetNumber?: string; // Device reference number
  extraItems?: string; // Additional information

  // State
  checkInTime?: Date;
  state: "success" | "error" | "loading" | "missing";
  isPrinted: boolean;
  isExtra: boolean;
  errorMessage?: string;
}

export const REMOVED_VIA_INVENTORY_STATE_ID = 459;

export const isInboundHelpOpenAtom = atomWithStorage(
  "showInboundHelp",
  true,
  undefined,
  { getOnInit: true },
);

export const isAutoPrintAtom = atom<boolean>(false);

export const targetOrderIdAtom = atomWithStorage<number | undefined>(
  "inboundTargetOrderId",
  undefined,
  createJSONStorage<number | undefined>(() => sessionStorage),
  { getOnInit: true },
);

const scannedDevicesStorage = createJSONStorage<ScannedDevice[]>(
  () => sessionStorage,
);

const settledScannedDevicesStorage = {
  ...scannedDevicesStorage,
  getItem: (key: string, initialValue: ScannedDevice[]) => {
    const devices = scannedDevicesStorage.getItem(key, initialValue);
    return devices?.filter((device) => device.state !== "loading") ?? devices;
  },
  setItem: (key: string, devices: ScannedDevice[]) => {
    scannedDevicesStorage.setItem(
      key,
      devices.filter((device) => device.state !== "loading"),
    );
  },
};

export const scannedDevicesAtom = atomWithStorage<ScannedDevice[]>(
  "inboundScannedDevices",
  [],
  settledScannedDevicesStorage,
  { getOnInit: true },
);
